import { defineMessages } from 'react-intl'
import moment from 'moment'
import { doGetLastTransactions, doGetLastDocuments, doGetServiceQuickLinks, doGetServicesCarousel } from '../routes/Homepage/modules/HomepageActions'
import { doGetNewMessages, doGetNewDocuments, doGetResultsGraphViewed } from '../store/actions/userProfiling'
import { doGetAuthorizedTransactions, doGetAccountedTransactions, doGetTransactionsTab, resetTransactionsState } from '../routes/Transactions/modules/TransactionsActions'
import { doGetNewDocuments as doGetNewDocumentsDoc, doGetBankStatements, doGetInvoices, doGetTaxCredit, doGetOtherDocuments, doGetTabs } from '../routes/Documents/modules/DocumentsActions'
import { doGetPerformanceChart, doGetBestPerformance, doGetGroupByCost, doGetGroupByCountry, doGetTotalClients, doGetGroupByCardBrand } from '../routes/Results/modules/ResultsActions'
import { capitalizeFirstLetter } from 'Utility/globalMethods'

// Messaggi specifici per le label del CostsShopSelector
export const costsCodeLabelMessages = defineMessages({
  locationCode: {
    id: 't.app.companydata.detail.shopLocationCode',
    defaultMessage: 'Codice location'
  },
  shopCode: {
    id: 't.app.companydata.detail.shopCode',
    defaultMessage: 'Codice punto vendita'
  },
  merchantCode: {
    id: 't.app.companydata.detail.merchantCode',
    defaultMessage: 'Codice Commerciante'
  },
  companyCode: {
    id: 't.app.companydata.detail.companyCode',
    defaultMessage: 'Codice societario'
  },
  siaMerchantCode: {
    id: 't.app.companydata.detail.SIAMerchantCode',
    defaultMessage: 'Codice esercente SIA'
  },
  paymentContract: {
    id: 't.app.companydata.detail.paymentContract',
    defaultMessage: 'Payment contract'
  },
  establishmentCode: {
    id: 't.app.shopSelector.codeType.child.uci',
    defaultMessage: 'Codice stabilimento'
  }
})

export const typeLabelMapper = defineMessages({
  C: {
    id: 't.app.shopSelector.type.c',
    defaultMessage: 'Migrati core'
  },
  N: {
    id: 't.app.shopSelector.type.n',
    defaultMessage: 'Non migrati core'
  },
  ND: {
    id: 't.app.shopSelector.type.nd',
    defaultMessage: 'Nexi Direct'
  },
  I: {
    id: 't.app.shopSelector.type.i',
    defaultMessage: 'Intesa Sanpaolo'
  },
  GT: {
    id: 't.app.shopSelector.type.gt',
    defaultMessage: 'Altri terminali'
  },
  UM: {
    id: 't.app.shopSelector.type.um',
    defaultMessage: 'Migrati'
  }
})

const labelIds = {
  codeLabels: {
    I: 't.app.shopSelector.codeType.i',
    ND: 't.app.shopSelector.codeType.nd',
    C: 't.app.shopSelector.codeType.c',
    N: 't.app.shopSelector.codeType.n',
    GT: 't.app.shopSelector.codeType.gt',
    UM: 't.app.shopSelector.codeType.um',
  },
  childrenCodeLabels: {
    I: 't.app.shopSelector.codeType.child.i',
    ND: 't.app.shopSelector.codeType.child.nd',
    C: 't.app.shopSelector.codeType.child.c',
    N: 't.app.shopSelector.codeType.child.n',
    GT: 't.app.shopSelector.codeType.child.gt',
    UM: 't.app.shopSelector.codeType.child.n',
  }
}

export const codeLabelMessages = defineMessages({
  't.app.shopSelector.codeType.i': {
    id: 't.app.shopSelector.codeType.i',
    defaultMessage: 'Codice societario'
  },
  't.app.shopSelector.codeType.child.i': {
    id: 't.app.shopSelector.codeType.child.i',
    defaultMessage: 'Codice commerciante'
  },
  't.app.shopSelector.codeType.nd': {
    id: 't.app.shopSelector.codeType.nd',
    defaultMessage: 'Codice societario'
  },
  't.app.shopSelector.codeType.child.nd': {
    id: 't.app.shopSelector.codeType.child.nd',
    defaultMessage: 'Codice commerciante'
  },
  't.app.shopSelector.codeType.c': {
    id: 't.app.shopSelector.codeType.c',
    defaultMessage: 'Codice location'
  },
  't.app.shopSelector.codeType.child.c': {
    id: 't.app.shopSelector.codeType.child.c',
    defaultMessage: 'Payment contract'
  },
  't.app.shopSelector.codeType.n': {
    id: 't.app.shopSelector.codeType.n',
    defaultMessage: 'Codice societario'
  },
  't.app.shopSelector.codeType.um': {
    id: 't.app.shopSelector.codeType.um',
    defaultMessage: 'Codice location'
  },
  't.app.shopSelector.codeType.child.n': {
    id: 't.app.shopSelector.codeType.child.n',
    defaultMessage: 'Codice punto vendita'
  },
  't.app.shopSelector.codeType.gt': {
    id: 't.app.shopSelector.codeType.gt',
    defaultMessage: 'Codice esercente SIA'
  },
  't.app.shopSelector.codeType.child.gt': {
    id: 't.app.shopSelector.codeType.child.gt',
    defaultMessage: 'Codice esercente SIA'
  },
  't.app.shopSelector.codeType.child.uci': {
    id: 't.app.shopSelector.codeType.child.uci',
    defaultMessage: 'Codice stabilimento'
  },
  't.app.shopSelector.codeType.uci': {
    id: 't.app.shopSelector.codeType.uci',
    defaultMessage: 'Codice Esercente'
  },
  't.app.shopSelector.codeType.child.migratedUci': {
    id: 't.app.shopSelector.codeType.child.migratedUci',
    defaultMessage: 'Codice stabilimento'
  },
  't.app.shopSelector.codeType.migratedUci': {
    id: 't.app.shopSelector.codeType.migratedUci',
    defaultMessage: 'Codice location'
  }
})

export const childrenTypologyLabelMapper = defineMessages({
  PBL: {
    id: 't.app.shopSelector.childType.pbl',
    defaultMessage: 'Pay By Link'
  },
  P: {
    id: 't.app.shopSelector.childType.p',
    defaultMessage: 'Negozio Fisico'
  },
  E: {
    id: 't.app.shopSelector.childType.e',
    defaultMessage: 'E-Commerce'
  },
  C: {
    id: 't.app.shopSelector.childType.c',
    defaultMessage: 'Core'
  },
  M: {
    id: 't.app.shopSelector.childType.m',
    defaultMessage: 'Misto'
  },
  unknown: {
    id: 't.app.shopType.unknown',
    defaultMessage: 'Tipo Sconosciuto'
  }
})

export const mergeSelections = (oldList = [], newList = []) => {
  const map = new Map()

  // Inserisci vecchi selezionati
  oldList.forEach(entry => {
    map.set(entry.parent.code, entry)
  })

  // Merge con nuovi selezionati (se ci sono duplicati, fai merge dei shops)
  newList.forEach(entry => {
    const existing = map.get(entry.parent.code)
    if (existing) {
      // Merge dei shops: mantieni i vecchi shops selezionati e aggiungi/aggiorna i nuovi
      const shopsMap = new Map()
        ; (existing.shops || []).forEach(shop => {
          shopsMap.set(shop.code, shop)
        })
        ; (entry.shops || []).forEach(shop => {
          shopsMap.set(shop.code, shop)
        })
      map.set(entry.parent.code, {
        ...entry,
        parent: {
          ...entry.parent,
          // Mantieni shopId se non presente nel nuovo
          shopId: entry.parent.shopId ?? existing.parent.shopId
        },
        shops: Array.from(shopsMap.values())
      })
    } else {
      map.set(entry.parent.code, entry)
    }
  })

  return Array.from(map.values())
}

export const normalizeShopSelectionPayload = ({ group, data, selectorGroups }) => {
  const codeToId = {}
  if (Array.isArray(selectorGroups)) {
    selectorGroups.forEach(groupObj => {
      (groupObj.shopsList || []).forEach(parent => {
        if (parent.shopId !== undefined && parent.shopId !== null) {
          codeToId[parent.code] = parent.shopId
        }
        (parent.shops || []).forEach(shop => {
          if (shop.shopId !== undefined && shop.shopId !== null) {
            codeToId[shop.code] = shop.shopId
          }
        })
      })
    })
  }

  const shopIds = []

  data.forEach(({ parent, shops }) => {
    if (group === 'OTHER') {
      // Solo parent selezionati (non avranno mai figli)
      // Usa direttamente parent.shopId se disponibile, altrimenti fallback su codeToId
      const shopId = parent.shopId !== undefined && parent.shopId !== null
        ? parent.shopId
        : codeToId[parent.code]
      if (parent.isSelected && shopId !== undefined && shopId !== null) {
        shopIds.push(shopId)
      }
    } else {
      if (!shops || shops.length === 0) {
        // Parent senza figli: se selezionato, aggiungi shopId
        // Usa direttamente parent.shopId se disponibile, altrimenti fallback su codeToId
        const shopId = parent.shopId !== undefined && parent.shopId !== null
          ? parent.shopId
          : codeToId[parent.code]
        if (parent.isSelected && shopId !== undefined && shopId !== null) {
          shopIds.push(shopId)
        }
      } else {
        // Parent con figli: aggiungi shopId dei figli selezionati
        shops.filter(shop => shop.isSelected).forEach(shop => {
          // Usa direttamente shop.shopId se disponibile, altrimenti fallback su codeToId
          const shopId = shop.shopId !== undefined && shop.shopId !== null
            ? shop.shopId
            : codeToId[shop.code]
          if (shopId !== undefined && shopId !== null) {
            shopIds.push(shopId)
          }
        })
      }
    }
  })

  return { shopIds }
}

export const normalizeCostsShopSelectionPayload = ({ group, data, selectorGroups }) => {
  const codeToId = {}
  const codeToParent = {} // Mappa per trovare il parent di ogni shop

  if (Array.isArray(selectorGroups)) {
    selectorGroups.forEach(groupObj => {
      (groupObj.shopsList || []).forEach(parent => {
        if (parent.shopId !== undefined && parent.shopId !== null) {
          codeToId[parent.code] = parent.shopId
        }
        (parent.shops || []).forEach(shop => {
          if (shop.shopId !== undefined && shop.shopId !== null) {
            codeToId[shop.code] = shop.shopId
            codeToParent[shop.code] = parent // Mappa shop al parent
          }
        })
      })
    })
  }

  const shopIds = []
  let location = ""

  data.forEach(({ parent, shops }) => {
    if (group === 'OTHER') {
      // Solo parent selezionati (non avranno mai figli)
      // Per OTHER, prova sia con parent.code che con parent.shopCode
      const parentCode = parent.code || parent.shopCode
      const shopId = codeToId[parentCode]
      if (parent.isSelected && shopId !== undefined && shopId !== null) {
        shopIds.push(shopId)
        // Per OTHER, usa coServPoint del parent se disponibile
        if (parent.coServPoint) {
          location = parent.coServPoint
        }
      } else if (parent.isSelected && parent.shopId !== undefined && parent.shopId !== null) {
        // Fallback: usa direttamente parent.shopId se non troviamo il mapping
        shopIds.push(parent.shopId)
        if (parent.coServPoint) {
          location = parent.coServPoint
        }
      }
    } else {
      if (!shops || shops.length === 0) {
        // Parent senza figli: se selezionato, aggiungi shopId
        const shopId = codeToId[parent.code]
        if (parent.isSelected && shopId !== undefined && shopId !== null) {
          shopIds.push(shopId)
          // Usa coServPoint del parent se disponibile
          if (parent.coServPoint) {
            location = parent.coServPoint
          }
        }
      } else {
        // Parent con figli: aggiungi shopId dei figli selezionati
        shops.filter(shop => shop.isSelected).forEach(shop => {
          // Usa direttamente shop.shopId se disponibile, altrimenti fallback su codeToId
          const shopId = shop.shopId !== undefined && shop.shopId !== null
            ? shop.shopId
            : codeToId[shop.code]
          if (shopId !== undefined && shopId !== null) {
            shopIds.push(shopId)
            // Trova il parent originale tramite la mappa e usa il suo coServPoint
            const originalParent = codeToParent[shop.code]
            if (originalParent && originalParent.coServPoint) {
              location = originalParent.coServPoint
            }
          }
        })
      }
    }
  })

  return { shopIds, location }
}

export const normalizeDisputeShopSelectionPayload = ({ group, data, selectorGroups }) => {
  // Build a lookup from shop code → full normalized entry (which has secondaryCode = coServPoint)
  const codeToShop = {}
  if (Array.isArray(selectorGroups)) {
    selectorGroups.forEach(groupObj => {
      ;(groupObj.shopsList || []).forEach(shop => {
        codeToShop[shop.code] = shop
      })
    })
  }

  const shopIds = []

  data.forEach(({ parent }) => {
    if (!parent.isSelected) return
    const raw = codeToShop[parent.code] || parent
    if (raw.shopId !== undefined && raw.shopId !== null) shopIds.push(raw.shopId)
  })

  return { shopIds }
}

export const mapGtShop = (shop, intl) => ({
  name: capitalizeFirstLetter(shop.shopName),
  code: shop.shopCode,
  address: shop.shopAddress,
  typology: shop.shopType
    ? intl.formatMessage(childrenTypologyLabelMapper[shop.shopType] ?? childrenTypologyLabelMapper.unknown)
    : ''
})

export const normalizeShopList = (selectorGroups, intl) =>
  selectorGroups.map(group => ({
    group: typeof group.group === 'string' ? group.group.replaceAll('_', ' ') : '',
    selected: group.selected || false,
    shopsList: (Array.isArray(group.shopsList) ? group.shopsList : []).map(parent => {
      const labelType = parent.labelType

      const codeLabelId = labelIds.codeLabels[labelType]
      const childrenLabelId = labelIds.childrenCodeLabels[labelType]

      return {
        ...parent,
        codeLabel: codeLabelId && codeLabelMessages[codeLabelId]
          ? intl.formatMessage(codeLabelMessages[codeLabelId])
          : 'Code',
        typeLabel: parent.labelType && typeLabelMapper[parent.labelType]
          ? intl.formatMessage(typeLabelMapper[parent.labelType])
          : '',
        typologyLabel: parent.type ? intl.formatMessage(childrenTypologyLabelMapper[parent.type] ?? childrenTypologyLabelMapper.unknown) : '',
        isSelected: parent.selected,
        shops: (parent.shops || []).map(child => ({
          ...child,
          childrenCodelabel: childrenLabelId && codeLabelMessages[childrenLabelId]
            ? intl.formatMessage(codeLabelMessages[childrenLabelId])
            : 'Code',
          childrenTypologyLabel: child.shopType
            ? intl.formatMessage(childrenTypologyLabelMapper[child.shopType] ?? childrenTypologyLabelMapper.unknown)
            : '',
          isSelected: child.selected
        }))
      }
    })
  })
  )

/**
 * Flattens the dispute shop hierarchy (parent→shops[]) into a flat list.
 * Each leaf shop becomes a standalone selectable row in ShopSelector showing:
 * - Nome stabilimento (shops[n].labelTop)
 * - Codice stabilimento (shops[n].code)
 * - Codice location (parent.coServPoint)
 * - Indirizzo (shops[n].address || parent.address)
 * - Tipologia (shops[n].shopType)
 */
export const normalizeDisputeShopList = (selectorGroups, intl) =>
  selectorGroups.map(group => ({
    group: typeof group.group === 'string' ? group.group.replaceAll('_', ' ') : '',
    selected: group.selected || false,
    shopsList: (Array.isArray(group.shopsList) ? group.shopsList : []).flatMap(parent => {
      const hasChildren = parent.shops && parent.shops.length > 0

      if (!hasChildren) {
        // Flat format: the parent itself is the shop entry
        return [{
          code: parent.shopCode || parent.code || '',
          shopId: parent.shopId,
          title: parent.labelTop || '',
          address: parent.address || '',
          primaryCode: parent.shopCode || parent.code || '',
          primaryCodeLabel: codeLabelMessages['t.app.shopSelector.codeType.child.uci']
            ? intl.formatMessage(codeLabelMessages['t.app.shopSelector.codeType.child.uci'])
            : 'Codice Stabilimento',
          secondaryCode: parent.coServPoint || '',
          secondaryCodeLabel: codeLabelMessages['t.app.shopSelector.codeType.um']
            ? intl.formatMessage(codeLabelMessages['t.app.shopSelector.codeType.um'])
            : 'Codice location',
          typologyLabel: parent.type
            ? intl.formatMessage(childrenTypologyLabelMapper[parent.type] ?? childrenTypologyLabelMapper.unknown)
            : '',
          isSelected: parent.selected || false,
          selected: parent.selected || false,
          shops: []
        }]
      }

      // Nested format: flatten children
      return parent.shops.map(child => ({
        code: child.code,
        shopId: child.shopId,
        title: child.labelTop || '',
        address: child.address || parent.address || '',
        primaryCode: child.code,
        primaryCodeLabel: codeLabelMessages['t.app.shopSelector.codeType.child.uci']
          ? intl.formatMessage(codeLabelMessages['t.app.shopSelector.codeType.child.uci'])
          : 'Codice Stabilimento',
        secondaryCode: parent.coServPoint || '',
        secondaryCodeLabel: codeLabelMessages['t.app.shopSelector.codeType.um']
          ? intl.formatMessage(codeLabelMessages['t.app.shopSelector.codeType.um'])
          : 'Codice location',
        typologyLabel: child.type
          ? intl.formatMessage(childrenTypologyLabelMapper[child.type] ?? childrenTypologyLabelMapper.unknown)
          : '',
        isSelected: child.selected || false,
        selected: child.selected || false,
        shops: []
      }))
    })
  }))

export const normalizeCostsShopList = (selectorGroups, intl) =>
  selectorGroups.map(group => ({
    group: group.group, // Mantiene il valore originale per la logica (es: INTESA_SANPAOLO)
    groupDisplay: typeof group.group === 'string' ? group.group.replaceAll('_', ' ') : '', // Per la visualizzazione UI
    selected: group.selected || false,
    shopsList: (Array.isArray(group.shopsList) ? group.shopsList : []).map(parent => {
      const groupName = group.group
      const hasChildren = parent.shops && parent.shops.length > 0

      // Oggetto per gestire multiple labels e codici
      let codeFields = []
      let label = parent.title || parent.labelTop
      let address = parent.address

      if (hasChildren) {
        // PADRI CON FIGLI: codici location
        if (parent.coServPoint) {
          codeFields.push({
            label: intl.formatMessage(costsCodeLabelMessages.locationCode),
            code: parent.coServPoint
          })
        }
      } else {
        // PADRI SENZA FIGLI: logica specifica per gruppo
        if (groupName === 'NEXI') {
          if (parent.coServPoint) {
            // coServPoint valorizzato -> solo codice location, NO codeCompany
            codeFields.push({
              label: intl.formatMessage(costsCodeLabelMessages.locationCode),
              code: parent.coServPoint
            })
          } else if (parent.shopCode) {
            // shopCode valorizzato -> codice punto vendita + codice societario
            codeFields.push({
              label: intl.formatMessage(costsCodeLabelMessages.shopCode),
              code: parent.shopCode
            })
            if (parent.codeCompany) {
              codeFields.push({
                label: intl.formatMessage(costsCodeLabelMessages.companyCode),
                code: parent.codeCompany
              })
            }
          }
        } else if (groupName === 'NEXI_DIRECT') {
          // Stessa logica di NEXI: shopCode + codeCompany
          if (parent.shopCode) {
            codeFields.push({
              label: intl.formatMessage(costsCodeLabelMessages.merchantCode),
              code: parent.shopCode
            })
          }
          if (parent.codeCompany) {
            codeFields.push({
              label: intl.formatMessage(costsCodeLabelMessages.companyCode),
              code: parent.codeCompany
            })
          }
        } else if (groupName === 'INTESA_SANPAOLO') {
          // Codice commerciante (shopCode) + Codice societario (codeCompany)
          if (parent.shopCode) {
            codeFields.push({
              label: intl.formatMessage(costsCodeLabelMessages.merchantCode),
              code: parent.shopCode
            })
          }
          if (parent.codeCompany) {
            codeFields.push({
              label: intl.formatMessage(costsCodeLabelMessages.companyCode),
              code: parent.codeCompany
            })
          }
        } else if (groupName === 'OTHER') {
          // Mai companyCode, solo codice esercente SIA
          if (parent.shopCode) {
            codeFields.push({
              label: intl.formatMessage(costsCodeLabelMessages.siaMerchantCode),
              code: parent.shopCode
            })
          }
        }
      }

      // Per retrocompatibilità, mantieni i campi singoli usando il primo codice
      const primaryCode = codeFields[0] || { label: 'Code', code: parent.code }
      const isEstablishment = parent.labelType === 'UM' || groupName === 'MIGRATED' || groupName === 'NOT_MIGRATED'

      return {
        ...parent,
        title: label,
        code: primaryCode.code,
        codeLabel: primaryCode.label,
        codeFields: codeFields, // Nuovo campo per gestire multiple labels
        address: address,
        labelSelection: parent.labelSelection,
        shopId: parent.shopId,
        typologyLabel: parent.type ? intl.formatMessage(childrenTypologyLabelMapper[parent.type] ?? childrenTypologyLabelMapper.unknown) : '',
        isSelected: parent.selected,
        shops: (parent.shops || []).map(child => ({
          ...child,
          code: child.paymentContract || child.code,
          childrenCodelabel: intl.formatMessage(
            isEstablishment ? costsCodeLabelMessages.establishmentCode : costsCodeLabelMessages.paymentContract
          ),
          childrenTypologyLabel: child.shopType
            ? intl.formatMessage(childrenTypologyLabelMapper[child.shopType] ?? childrenTypologyLabelMapper.unknown)
            : '',
          isSelected: child.selected
        }))
      }
    })
  })
  )

const transactionsRequestParamsDefault = {
  startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), // Seven days ago,
  endDate: moment().format('YYYY-MM-DD'), // Today's date
  pageNumber: 1,
  pageSize: 30,
  filterType: {},
  customPeriod: null
}

export const pathDispatchMap = {
  '/': [
    doGetLastTransactions,
    doGetLastDocuments,
    doGetServiceQuickLinks,
    doGetServicesCarousel,
    doGetNewMessages,
    doGetNewDocuments,
    doGetResultsGraphViewed
  ],

  '/transactions': {
    AUTHORIZED: [doGetTransactionsTab, () => doGetAuthorizedTransactions(transactionsRequestParamsDefault)],
    ACCOUNTED: [doGetTransactionsTab, () => doGetAccountedTransactions(transactionsRequestParamsDefault)]
  },

  '/documents': {
    OVERVIEW: [doGetTabs, doGetNewDocumentsDoc],
    BANK_STATEMENTS: [doGetTabs, doGetBankStatements, doGetNewDocumentsDoc],
    INVOICES: [doGetTabs, doGetInvoices, doGetNewDocumentsDoc],
    TAX_CREDIT: [doGetTabs, doGetTaxCredit, doGetNewDocumentsDoc],
    OTHER_DOCUMENTS: [doGetTabs, doGetOtherDocuments, doGetNewDocumentsDoc]
  },

  '/results': {
    ONE_PERIOD: [doGetPerformanceChart, doGetBestPerformance, doGetGroupByCost, doGetGroupByCountry, doGetTotalClients, doGetGroupByCardBrand],
    TWO_PERIODS: [doGetPerformanceChart, doGetBestPerformance, doGetGroupByCost, doGetGroupByCountry, doGetTotalClients, doGetGroupByCardBrand]
  }
}

export const getActionsForPath = (pathname, tabKey) => {
  const entry = pathDispatchMap[pathname]
  if (!entry) return []

  if (Array.isArray(entry)) return entry

  // path con tab
  if (tabKey && entry[tabKey]) return entry[tabKey]

  const merged = [...new Set(Object.values(entry).flat())]
  return merged
}

export const mergeSelectionWithParents = (parents, selections) => {
  const selectionMap = new Map(
    (selections || []).map(entry => [
      entry.parent.code,
      {
        parentSelected: entry.parent?.isSelected === true,
        childStates: Object.fromEntries((entry.shops || []).map(s => [s.code, s.isSelected === true]))
      }
    ])
  )

  return (Array.isArray(parents) ? parents : []).map(parent => {
    const sel = selectionMap.get(parent.code)
    const hasChildren = Array.isArray(parent.shops) && parent.shops.length > 0

    let isSelected
    if (!hasChildren) {
      // Parent senza figli: la selezione è solo sul parent
      isSelected = sel?.parentSelected ?? parent.isSelected === true
    } else {
      // Parent con figli: la selezione dipende dai figli
      isSelected = sel?.parentSelected || false
    }

    const shops = (parent.shops || []).map(child => {
      const hasChildStates = sel && sel.childStates && typeof sel.childStates === 'object'
      const isChildSelected = hasChildStates && Object.prototype.hasOwnProperty.call(sel.childStates, child.code)
        ? sel.childStates[child.code]
        : child.isSelected === true
      return { ...child, isSelected: isChildSelected }
    })

    return {
      ...parent,
      shops,
      isSelected
    }
  })
}

export const transformFlatShopsToHierarchical = (flatShops, intl) => {
  if (!Array.isArray(flatShops) || flatShops.length === 0) {
    return []
  }

  return flatShops.map(shop => {
    const addressString = shop.address
      ? `${shop.address.street}, ${shop.address.city}, ${shop.address.province} ${shop.address.postIndex}, ${shop.address.country}`
      : ''

    const labelType = shop.labelType || 'GT'
    const codeLabelId = labelIds.codeLabels[labelType]
    const childrenLabelId = labelIds.childrenCodeLabels[labelType]

    return {
      title: shop.shopName,
      shopId: shop.shopId,
      code: shop.shopCode,
      labelType: labelType,
      type: shop.shopType,
      address: addressString,
      selected: false,
      codeLabel: codeLabelId && codeLabelMessages[codeLabelId] && intl
        ? intl.formatMessage(codeLabelMessages[codeLabelId])
        : 'Code',
      typeLabel: labelType && typeLabelMapper[labelType] && intl
        ? intl.formatMessage(typeLabelMapper[labelType])
        : '',
      typologyLabel: shop.shopType && intl
        ? intl.formatMessage(childrenTypologyLabelMapper[shop.shopType] || childrenTypologyLabelMapper.unknown)
        : '',
      isSelected: false,
      shops: [] // No child shops in this structure
    }
  })
}
